var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.075 21C10.825 21 9.65 20.7625 8.55 20.2875C7.45 19.8125 6.4875 19.1667 5.6625 18.35C4.8375 17.5333 4.1875 16.575 3.7125 15.475C3.2375 14.375 3 13.2 3 11.95C3 10.7 3.2375 9.53333 3.7125 8.45C4.1875 7.36667 4.8375 6.42083 5.6625 5.6125C6.4875 4.80417 7.45 4.16667 8.55 3.7C9.65 3.23333 10.825 3 12.075 3C13.4083 3 14.6708 3.29167 15.8625 3.875C17.0542 4.45833 18.0833 5.25833 18.95 6.275V3.625H20.45V8.825H15.225V7.325H17.85C17.1167 6.475 16.2542 5.79167 15.2625 5.275C14.2708 4.75833 13.2083 4.5 12.075 4.5C9.99167 4.5 8.20833 5.2125 6.725 6.6375C5.24167 8.0625 4.5 9.80833 4.5 11.875C4.5 13.9917 5.23333 15.7917 6.7 17.275C8.16667 18.7583 9.95833 19.5 12.075 19.5C14.1583 19.5 15.9167 18.7667 17.35 17.3C18.7833 15.8333 19.5 14.0583 19.5 11.975H21C21 14.475 20.1333 16.6042 18.4 18.3625C16.6667 20.1208 14.5583 21 12.075 21ZM15.125 16.075L11.275 12.275V6.925H12.775V11.65L16.2 15L15.125 16.075Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/HistoryIcon.24b93d5ae69aa499f5ef8097c54aa98b.svg";
export { ForwardRef as ReactComponent };